import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c7fe0470"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mt-10 mb-10 pb-20" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, null, -1))
const _hoisted_3 = { class: "col-6 backCard" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "fs-4 fw-bold titulo" }, "Daños y desperfectos", -1))
const _hoisted_5 = { class: "fv-row mb-5" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-base ms-3 fw-bold text-dark" }, "Descripción", -1))
const _hoisted_7 = { class: "fv-plugins-message-container" }
const _hoisted_8 = { class: "fv-help-block" }
const _hoisted_9 = { class: "fv-row mb-5" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-base ms-3 fw-bold text-dark" }, "Imágenes", -1))
const _hoisted_11 = { class: "mt-10" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { class: "mt-4" }
const _hoisted_14 = { class: "ulImages text-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spanIzq" }, " < ", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spanDer" }, " > ", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-12" }
const _hoisted_22 = { class: "containerImages" }
const _hoisted_23 = { class: "listadoImagenes" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["src", "onClick"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_Form, {
          class: "form",
          id: "kt_desperfectos_form",
          onInvalidSubmit: _ctx.onInvalidSubmit,
          onSubmit: _ctx.save,
          "validation-schema": _ctx.desperfectos,
          ref: "desperfectosRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_Field, {
                class: "form-control form-control-sm form-control-solid description p-5 m-5",
                type: "text",
                name: "descDefectos",
                ref: "descDefectos",
                modelValue: _ctx.initialValues.descDefectos,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.initialValues.descDefectos) = $event)),
                autocomplete: "off",
                placeholder: "Escribe los desperfectos que el vehículo pudiera tener",
                as: "textarea",
                style: {"resize":"none"}
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_ErrorMessage, { name: "descDefectos" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "file",
                name: "inputFileDes",
                multiple: "",
                accept: "image/*",
                id: "inputFileDes",
                ref: "inputFileDes",
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.getFilesInputDes && _ctx.getFilesInputDes(...args)))
              }, null, 544), [
                [_vShow, false]
              ]),
              _hoisted_10,
              _withDirectives(_createElementVNode("span", {
                class: "spanSeleccionaImagenes float-end",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.agregarImagenesDes && _ctx.agregarImagenesDes(...args)))
              }, "Agregar más imagenes", 512), [
                [_vShow, _ctx.imagesDes.length > 0]
              ]),
              _createElementVNode("div", {
                onDrop: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.dropEventDes && _ctx.dropEventDes(...args)), ["prevent"])),
                onDragenter: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.checkDataDes && _ctx.checkDataDes(...args))),
                onDragover: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.checkDataDes && _ctx.checkDataDes(...args))),
                class: _normalizeClass((_ctx.imagesDes.length == 0 && !_ctx.isEdit) || (_ctx.isEdit && _ctx.imagesThumDes.length == 0 && _ctx.imagesDes.length == 0) ? 'dropZoneD dzBorderD text-center': 'dropZoneAutoD')
              }, [
                _withDirectives(_createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_inline_svg, {
                    src: "media/icons/iconsax/gallery-add.svg",
                    height: "100",
                    width: "100",
                    class: "mb-5"
                  }),
                  _hoisted_12,
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    type: "button",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.agregarImagenesDes && _ctx.agregarImagenesDes(...args)))
                  }, "Agregar imágenes"),
                  _createElementVNode("p", _hoisted_13, [
                    _createTextVNode("Arrastra las imágenes de tu vehículo o "),
                    _createElementVNode("span", {
                      class: "spanSeleccionaImagenes",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.agregarImagenesDes && _ctx.agregarImagenesDes(...args)))
                    }, "selecciona las imágenes")
                  ])
                ], 512), [
                  [_vShow, (_ctx.imagesDes.length == 0 && !_ctx.isEdit) || (_ctx.isEdit && _ctx.imagesThumDes.length == 0 && _ctx.imagesDes.length == 0)]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-primary btnIzqRounded btnIzqDes",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.prevImageDes && _ctx.prevImageDes(...args)))
                    }, _hoisted_16, 512), [
                      [_vShow, _ctx.indexImageDes > 0 && _ctx.imagesThumDes.length > 0]
                    ]),
                    _withDirectives(_createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-primary btnDerRounded btnDerDes",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.nextImageDes && _ctx.nextImageDes(...args)))
                    }, _hoisted_18, 512), [
                      [_vShow, _ctx.imagesThumDes.length > 0 && (_ctx.indexImageDes + 1) < _ctx.imagesThumDes.length]
                    ]),
                    _createElementVNode("img", {
                      src: _ctx.isEdit && _ctx.imagesThumDes.length > 0 ? _ctx.imagesThumDes[_ctx.indexImageDes].path : _ctx.imagesThumDes[_ctx.indexImageDes],
                      class: "imgPrincipal",
                      alt: ""
                    }, null, 8, _hoisted_19),
                    _withDirectives(_createElementVNode("span", { class: "contadorImagenes" }, _toDisplayString(_ctx.isEdit ? _ctx.imagesThumDes.length : _ctx.imagesDes.length) + " - 5", 513), [
                      [_vShow, _ctx.imagesDes.length > 0 || _ctx.isEdit]
                    ])
                  ])
                ], 512), [
                  [_vShow, _ctx.imagesDes.length > 0]
                ])
              ], 34)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("ul", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imagesThumDes, (img, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "liAbsolute",
                        key: index
                      }, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-danger btn-sm btnDerRounded btnLiTrash",
                          onClick: ($event: any) => (_ctx.eliminarImagenDes(index)),
                          title: "Eliminar imagen"
                        }, [
                          _createVNode(_component_inline_svg, {
                            src: "media/icons/iconsax/trash.svg",
                            class: "trashButton"
                          })
                        ], 8, _hoisted_24),
                        _createElementVNode("img", {
                          class: "vehiculoImagenDes",
                          src: _ctx.isEdit ? img.path : img,
                          alt: "Automóvil",
                          onClick: ($event: any) => (_ctx.setImageDes(index))
                        }, null, 8, _hoisted_25)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onInvalidSubmit", "onSubmit", "validation-schema"])
      ]),
      _hoisted_26
    ])
  ]))
}